module.exports = __webpack_public_path__ + "img/fumo.bc36ff3a.jpg";